export { createSitecoreAdapter } from './adapter';
export type { SitecoreRequest } from './adapter';
